import { Action } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { LoginHistoryModel, FailedLoginModel } from '../ProfileModels'

export interface ActionWithPayload<T> extends Action {
    payload?: T
}
export const actionTypes = {
    SetFailedLogins: '[SetFailedLogins] Action',
    SetLoginHistory: '[SetLoginHistory] Action'
}

export interface IProfileState {
    failedLogins?: Array<FailedLoginModel>,
    loginHistory?: Array<LoginHistoryModel>
}

const initialState: IProfileState = {
    failedLogins: undefined,
    loginHistory: undefined,
}

export const reducer = persistReducer(
    { storage, key: 'kpmrc-profile', whitelist: ['failedLogins', 'loginHistory'] },
    (state: IProfileState = initialState, action: ActionWithPayload<IProfileState>) => {
        switch (action.type) {
            case actionTypes.SetFailedLogins: {
                let failedLogins = action.payload?.failedLogins
                if (failedLogins) {
                    failedLogins = (state.failedLogins ?? []).concat(failedLogins);
                    failedLogins = failedLogins.filter((item, idx) => (failedLogins ?? []).indexOf(item) === idx)
                }
                return { ...state, failedLogins }
            }
            case actionTypes.SetLoginHistory: {
                let loginHistory = action.payload?.loginHistory
                if (loginHistory) {
                    loginHistory = (state.loginHistory ?? []).concat(loginHistory);
                    loginHistory = loginHistory.filter((item, idx) => (loginHistory ?? []).indexOf(item) === idx)
                }
                return { ...state, loginHistory }
            }

            default:
                return state
        }
    }
)

export const actions = {
    setFailedLoginList: (failedLogins: Array<FailedLoginModel>) => ({ type: actionTypes.SetFailedLogins, payload: { failedLogins } }),
    setLoginHistoryList: (loginHistory: Array<LoginHistoryModel>) => ({ type: actionTypes.SetLoginHistory, payload: { loginHistory } })
}